import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEligibleCanvasResult = objectOf({
  eligible_workflow_steps: arrayOf(
    objectOf({
      id: string,
      value: string,
    })
  ),
});
